import { useState } from "react";

const UNDERLINE_REST = "var(--chat-input-border)";
const UNDERLINE_FOCUS = "var(--chat-input-border-focus)";

/**
 * Focus-strengthening underline for form controls. These inputs style their
 * underline inline to match the surrounding inline-styled controls, and inline
 * styles can't be targeted by a `:focus` rule, so the focus colour is driven
 * from React state.
 */
export function useUnderline() {
  const [focused, setFocused] = useState(false);
  return {
    borderColor: focused ? UNDERLINE_FOCUS : UNDERLINE_REST,
    onFocus: () => setFocused(true),
    onBlur: () => setFocused(false),
  };
}
